<template>
<div class="chapter">
<div class="inner_page">
<p class="titletop n"><span class="textStyle5">ROWMAN &amp; LITTLEFIELD PUBLISHERS, INC.</span></p>
<p class="n topbottom1"><span class="textStyle5">Published in the United States of America<br/>
  by Rowman &amp; Littlefield Publishers, Inc.</span><br/>
<span class="textStyle5">A wholly owned subsidiary of The Rowman &amp; Littlefield Publishing Group, Inc.<br/>
  4501 Forbes Boulevard, Suite 200, Lanham, Maryland 20706<br/>
<a href="http://www.rowmanlittlefield.com" target="_blank">www.rowmanlittlefield.com</a></span></p>
<p class="n topbottom1"><span class="textStyle5">Estover Road</span><br/>
<span class="textStyle5">Plymouth PL6 7PY<br/>
  United Kindom</span></p>
<p class="n topbottom1"><span class="textStyle5">Copyright © 2007 by Rowman &amp; Littlefield Publishers, Inc.</span></p>
<p class="left n topbottom1"><span class="textStyle6">All rights reserved.</span> <span class="textStyle5">No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publisher.</span></p>
<p class="n topbottom1"><span class="textStyle5">British Library Cataloguing in Publication Information Available</span></p>
<p class="n topbottom1"><span class="textStyle7">Library of Congress Cataloging-in-Publication Data</span></p>
<p class="n"><span class="textStyle5">Buchenau, Jürgen, 1964–</span></p>
<p class="ext1"><span class="textStyle5">Plutarco Elías Calles and the Mexican Revolution / Jürgen Buchenau.</span></p>
<p><span class="textStyle5">p. cm. — (Latin American silhouettes)</span></p>
<p class="ext1"><span class="textStyle5">Includes bibliographical references and index.</span></p>
<p class="ext1"><span class="textStyle5">ISBN-13: 978-0-7425-3748-4 (cloth : alk. paper)</span></p>
<p class="ext1"><span class="textStyle5">ISBN-10: 0-7425-3748-X (cloth : alk. paper)</span></p>
<p class="ext1"><span class="textStyle5">ISBN-13: 978-0-7425-3749-1 (pbk. : alk. paper)</span></p>
<p class="ext1"><span class="textStyle5">ISBN-10: 0-7425-3749-8 (pbk. : alk. paper)</span></p>
<p class="ext2"><span class="textStyle5">1. Calles, Plutarco Elías, 1877–1945. 2. Mexico—History—Revolution, 1910–1920. 3. Mexico—Politics and government—1910–1946. 4. Presidents—Mexico—</span></p>
<p class="ext3"><span class="textStyle5">Biography. I. Title.</span></p>
<p class="ext3"><span class="textStyle5">F1234.C192B83 2007<br/>
  972.08'16092—dc22</span></p>
<p class="right"><span class="textStyle5">2006024488</span><br/>
<br/></p>
<p class="n topbottom1"><span class="textStyle5">Printed in the United States of America</span></p>
<p class="n left"><img alt="TM" src="Images/frn_fig_002.png"/> <span class="textStyle5">The paper used in this publication meets the minimum requirements of American National Standard for Information Sciences—Permanence of Paper for Printed Library Materials, ANSI/NISO Z39.48-1992.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?8f341340